
copyShareUrl = function () {
    var copyText = document.getElementById("share-url");

    copyText.select();
    copyText.setSelectionRange(0, 99999);

    document.execCommand("copy");
    showSnackbar();
}

showSnackbar = function () {
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () {
        x.className = x.className.replace("show", "");
    }, 3000);
}
